import { useState } from "react";
import { useTranslation } from "react-i18next";
import { CMButton } from "@chartmetric/chartmetric-design-system/components/CMButton";
import { CMPopover } from "@chartmetric/chartmetric-design-system/components/CMPopover";
import { faLanguage } from "@fortawesome/pro-regular-svg-icons/faLanguage";
import { faCheck } from "@fortawesome/pro-solid-svg-icons/faCheck";

import { SUPPORTED_LANGUAGES } from "../i18n/i18n";

const LANGUAGE_LABELS: Record<string, string> = {
  en: "English",
  de: "Deutsch",
  es: "Español",
  fr: "Français",
  ja: "日本語",
  ko: "한국어",
  pt: "Português",
};

function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);

  const currentLang =
    SUPPORTED_LANGUAGES.find((l) => i18n.language?.startsWith(l)) ?? "en";

  return (
    <CMPopover.Root open={open} onOpenChange={setOpen}>
      <CMPopover.Trigger asChild>
        <CMButton
          type="button"
          iconLeft={faLanguage}
          variant="secondaryText"
          size="sm"
        />
      </CMPopover.Trigger>
      <CMPopover.Portal>
        <CMPopover.Content align="end" sideOffset={6} zIndex={40}>
          {SUPPORTED_LANGUAGES.map((lang) => (
            <CMButton
              key={lang}
              type="button"
              text={LANGUAGE_LABELS[lang] ?? lang}
              variant={lang === currentLang ? "text" : "secondaryText"}
              size="sm"
              fullWidth
              onClick={() => {
                void i18n.changeLanguage(lang);
                setOpen(false);
              }}
            />
          ))}
        </CMPopover.Content>
      </CMPopover.Portal>
    </CMPopover.Root>
  );
}

export default LanguageSwitcher;
